import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/containers/FacilitiesPage.tsx");
